import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://eizzejuiprdviukttgdw.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVpenplanVpcHJkdml1a3R0Z2R3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEwNDg5MjMsImV4cCI6MjA2NjYyNDkyM30.wexL2ClATQhTIh_CKoGkPpyjZLvljMqF-n5c7wjoa7M'

if (supabaseUrl === 'https://your-project.supabase.co' || supabaseAnonKey === 'your-anon-key') {
  throw new Error('Missing Supabase variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
})

export const STORAGE_BUCKETS = {
  COVERS: 'book-covers',
  MOCKUPS: 'generated-mockups'
}